
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('availability-block') && (binding.modules['availability-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-availability-block' */
            'partner/modules/availability-block/availability-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'availability-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/availability-block'
    });
        

    isNotRegistered('availability-container') && (binding.modules['availability-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-availability-container' */
            'partner/modules/availability-container/availability-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'availability-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/availability-container'
    });
        

    isNotRegistered('basic') && (binding.modules['basic'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-basic' */
            'partner/themes/basic/basic.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'basic',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'basic.theme.settings.json',
        md: 'src/themes/basic'
    });
        

    isNotRegistered('burger') && (binding.modules['burger'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-burger' */
            'partner/modules/burger/burger.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'burger',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/burger'
    });
        

    isNotRegistered('category-page-container') && (binding.modules['category-page-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-category-page-container' */
            'partner/modules/category-page-container/category-page-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'category-page-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/category-page-container'
    });
        

    isNotRegistered('category-page-content-block') && (binding.modules['category-page-content-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-category-page-content-block' */
            'partner/modules/category-page-content-block/category-page-content-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'category-page-content-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/category-page-content-block'
    });
        

    isNotRegistered('contact-form') && (binding.modules['contact-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-contact-form' */
            'partner/modules/contact-form/contact-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'contact-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/contact-form'
    });
        

    isNotRegistered('fabrikam') && (binding.modules['fabrikam'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-fabrikam' */
            'partner/themes/fabrikam/fabrikam.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'fabrikam',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'fabrikam.theme.settings.json',
        md: 'src/themes/fabrikam'
    });
        

    isNotRegistered('harveystheme') && (binding.modules['harveystheme'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-harveystheme' */
            'partner/themes/harveystheme/harveystheme.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','content-block','media-gallery','navigation-menu','promo-banner','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'harveystheme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'harveystheme.theme.settings.json',
        md: 'src/themes/harveystheme'
    });
        

    isNotRegistered('img-block') && (binding.modules['img-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-img-block' */
            'partner/modules/img-block/img-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'img-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/img-block'
    });
        

    isNotRegistered('kasco') && (binding.modules['kasco'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-kasco' */
            'partner/themes/kasco/kasco.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','content-block','promo-banner','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'kasco',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'kasco.theme.settings.json',
        md: 'src/themes/kasco'
    });
        

    isNotRegistered('kasco-theme') && (binding.modules['kasco-theme'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-kasco-theme' */
            'partner/themes/kasco-theme/kasco-theme.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'kasco-theme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'kasco-theme.theme.settings.json',
        md: 'src/themes/kasco-theme'
    });
        

    isNotRegistered('product-detail-block') && (binding.modules['product-detail-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-detail-block' */
            'partner/modules/product-detail-block/product-detail-block.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'product-detail-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-detail-block'
    });
        

    isNotRegistered('product-detail-container') && (binding.modules['product-detail-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-detail-container' */
            'partner/modules/product-detail-container/product-detail-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'product-detail-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-detail-container'
    });
        

    isNotRegistered('product-list-block') && (binding.modules['product-list-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-list-block' */
            'partner/modules/product-list-block/product-list-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'product-list-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-list-block'
    });
        

    isNotRegistered('product-list-container') && (binding.modules['product-list-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-list-container' */
            'partner/modules/product-list-container/product-list-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'product-list-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-list-container'
    });
        

    isNotRegistered('request-form') && (binding.modules['request-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-request-form' */
            'partner/modules/request-form/request-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'request-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/request-form'
    });
        

    isNotRegistered('sniderstheme') && (binding.modules['sniderstheme'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sniderstheme' */
            'partner/themes/sniderstheme/sniderstheme.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','content-block','media-gallery','navigation-menu','promo-banner','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'sniderstheme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'sniderstheme.theme.settings.json',
        md: 'src/themes/sniderstheme'
    });
        

    isNotRegistered('socials-block') && (binding.modules['socials-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-socials-block' */
            'partner/modules/socials-block/socials-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'socials-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/socials-block'
    });
        

    isNotRegistered('table') && (binding.modules['table'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-table' */
            'partner/modules/table/table.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'table',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/table'
    });
        

    isNotRegistered('table-row') && (binding.modules['table-row'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-table-row' */
            'partner/modules/table-row/table-row.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'table-row',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/table-row'
    });
        

    isNotRegistered('youtube-embed') && (binding.modules['youtube-embed'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-youtube-embed' */
            'partner/modules/youtube-embed/youtube-embed.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'youtube-embed',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/youtube-embed'
    });
        

        {   
            const actionPath = 'actions/trigger-product-list.action';
            binding.dataActions[actionPath] = require('partner/actions/trigger-product-list.action');
            registerActionId(actionPath);
        }

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};